<template>
  <div class="s-mypost-card" :class="[
    {
      'post-tertiary': isGiveOrLend ,
    },
    {
      'post-offer': !isGiveOrLend ,
    },
    {
      'post-trade-complete': isTradeCompleted,
    },
  ]">
    <!-- Item Image -->
    <div class="item-thumb-wrapper">
      <div class="item-type-wrapper">
        <p class="item-type-text">
          You are
          <span class="item-trade-type-text request-trade-type" :class="[getTradeTypeClass]">
            {{ getTradeType }}
          </span>
        </p>
      </div>
      <div class="item-thumb-image" :class="[getPostBorder]">
        <img :src="getItemImagePath(activity)" alt="product" class="item-img"
          @click="goToItemDetails(activity)" />
      </div>
    </div>
    <!-- Item Content -->
    <div class="item-content-wrapper">
      <div class="item-content-header">
        <div data-toggle="tooltip" data-placement="top" :data-original-title="getItemTitle(item)" :data-html="true">
          <p class="item-content-header-nameItem" @click="goToItemDetails(item)" :data-cy="`linkItemDetails-${getItemTitle(activity)}`">
            {{ getItemTitle(item) }}
          </p>
        </div>

        <p class="item-content-header-posted">
          You posted on <time class="item-content-header-posted-date" datetime="2017-03-24T18:18"> {{ getTimeAgo(activity.createdAt) }} </time>
        </p>
      </div>

      <div class="item-content-body">
        <div class="item-content-body-wrapper" :class="[
          {
            'item-actions-confirm-sent':
              Object.keys(acceptedRequest).length > 0 &&
              !isTradeCompleted,
          },
          { 'item-actions-completed': isTradeCompleted },
        ]">
            <div class="item-body-payment-type">
              <!-- When user didn't accept a request yet, display item value: points, money, both or FREE -->
              <div class="item-payment-type" v-if=" !isTradeCompleted && Object.keys(acceptedRequest).length === 0 && !isAcceptedRequest">
                <div v-if="isFree">
                  <p class="item-price-mypost">
                    FREE
                  </p>
                </div>

                <div v-else>
                  <p class="item-price-mypost" v-if="acceptCash || acceptPoints">
                    <span v-if="acceptCash">{{ getItemPriceMoney }}</span>
                    <span v-if="acceptCash && acceptPoints"> or </span>
                    <span v-if="acceptPoints">
                      {{ getItemPricePoints.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                      <img class="mb-3" src="/img/Polygon_7.svg" alt="Swampum" width="12px" height="12px" />
                    </span>
                  </p>
                </div>
              </div>

              <!-- When user accept a request, display payment type -->
              <div class="item-payment-type" v-else>
                  <h5 class="item-price-mypost">
                    {{ getAcceptedRequestValue.value }}
                    <img class="mb-3" src="/img/Polygon_7.svg" alt="Swampum" width="12px" height="12px" v-if="getAcceptedRequestValue.type === 'points'" />
                  </h5>
              </div>
            </div>

            <!-- Did you send this item, request accepted box-->
            <div class="item-body-info-boxes" v-if="isAcceptedRequest && !isTradeCompleted">

              <div class="request-accepted-box" v-if="isAcceptedRequest && !isTradeCompleted && Object.keys(acceptedRequest).length === 0">
                <div class="request-accepted-box-icon">
                  <img src="/svg-icons/item-accept-icon.svg" alt="Item Accepted Request Icon" width="20px" height="20px">
                </div>

                <div class="request-accepted-box-text">
                  <p class="accept-text">{{ getTextFromItemType }}</p>
                  <span class="request-accepted-ontime-timestamp">You accepted on {{ getTimeStamp }}</span>
                </div>
              </div>

              <div v-if="Object.keys(acceptedRequest).length > 0 && !isTradeCompleted">
                  <ItemReceivedSentStatus @updateItemStatus="$emit('updateItemStatus')" :item="activity" :acceptedRequest="acceptedRequest" />
              </div>

              <div v-if="isTradeCompleted" class="trade-state-ontime" :class="[{ 'set-in-columns': isTradeCompleted }]">
                <span class="trade-completed-text" :data-cy="`requestStatus-${getItemTitle(activity)}`">
                    Trade Completed
                </span>
                <span class="ontime-timestamp">{{ getTimeStamp }}</span>
              </div>
            </div>
        </div>
      </div>

      <div class="item-content-actions">
        <div v-if="!isTradeCompleted && !isAcceptedRequest" :class="[
          'item-details-action',
          'item-details-interested',
          +interestedText !== 0 ? 'active' : 'disabled',
          ]"
          @click="goToInterestedItem(activity)"
        >
          <div class="item-details-action--buttonRequests">
            <SButtonMaterial
              class="interested-item-mypost-btn"
              :md-ripple="false"
              buttonType="button"
              color="transparent"
              :disabled="!itemHaveRequests"
              iconColor="white"
              :iconLeftText="getIconName"
              borderColor="noBorder"
              materialClass="dense"
            />
          </div>
          <span class="item-details-action-text">{{ requestNumberText }}</span>
        </div>
        <div class="item-details-action active messages" @click="openChat()">
          <div class="item-details-action--icon">
            <img src="/svg-icons/rounded-message-icon.svg" alt="message icon" width="20px" height="20px" />
          </div>
          <span class="item-details-action-text">Messages</span>
        </div>
      </div>
    </div>
    <ModalDeleteItem :item="item" :itemHaveRequests="itemHaveRequests" @deleteItem="updatePage()" />
  </div>
</template>

<script>
import itemType from "@/enum/item-type";
import itemStatus from "@/enum/item-status";
import requestSituation from "@/enum/request-situation";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import ItemReceivedSentStatus from "@/components/molecules/ItemReceivedSentStatus";
import ModalDeleteItem from "@/material-components/molecules/ModalDeleteItem.vue";
export default {
  name: "ActivityMyPost",
  props: ["item"],
  mixins: [ItemHelperVue, UserHelperVue],
  components: {
    SButtonMaterial,
    ItemReceivedSentStatus,
    ModalDeleteItem,
  },
  data() {
    return {
      iStatus: itemStatus,
      iType: itemType,
      reqSituation: requestSituation,
    };
  },
  methods: {
    openChat() {
      if (this.isUserAuthenticated) {
        this.$emit("openWindowPopup", this.item.id);
      } else {
        this.$router.push(`/s-app/item-details/${this.item.id}`);
      }
    },
    goToItemDetails(activity) {
      this.$router.push(`/s-app/item-details/${activity.id}`);
    },
    getTimeAgo(time) {
      const date = new Date(time);
      return date.toLocaleString('en-us', {dateStyle: 'short'});
    },
    openDeleteModal() {
      $(`#delete-item-${this.item.id}`).modal("show");
    },
    updatePage() {
      this.$router.go();
    },
    goToInterestedItem(activty) {
      if(+this.interestedText) {
        this.$router.push({
          path: `/s-app/item-details/${activty.id}`,
          query: { interested: 1 },
        });
      }
    },
    setUpdated(dueDate) {
      let updated = new Date();
      if (this.item.changeSituationAt) {
        updated = new Date(this.item.changeSituationAt);
        updated.setDate(updated.getDate() + dueDate);
      }
      return updated;
    }
  },
  computed: {
    activity() {
      return {
        ...this.item,
        user: this.loggedUser,
      };
    },
    showDeleteOption() {
      return this.getItemAvailability(this.item) || !this.itemHaveRequests;
    },
    isShowDot() {
      return this.editButtomAvailable(this.item) || this.showDeleteOption;
    },
    getPostBorder() {
      let type = this.activity?.type ?? "";
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-image-tertiary"
        : "border-image-offer";
    },
    isGiveOrLend() {
      let type = this.activity?.type ?? "";
      return type === itemType.GIVE || type === itemType.LEND;
    },
    getPosterUsername() {
      if (this.activity.user.username) return "@" + this.activity.user.username;
      return "";
    },
    isTradeCompleted() {
      return this.item.status === this.iStatus.RECEIVED;
    },
    getTradeTypeClass() {
      if (this.item) {
        if (this.item.type === this.iType.GIVE) {
          return "trade-type-give";
        } else if (this.item.type === this.iType.RECEIVE) {
          return "trade-type-receive";
        } else if (this.item.type === this.iType.LEND) {
          return "trade-type-lend";
        } else if (this.item.type === this.iType.BORROW) {
          return "trade-type-borrow";
        }
      }

      return "";
    },
    getTradeType() {
      if (this.item) {
        if (this.item.type === this.iType.GIVE) {
          return "giving";
        } else if (this.item.type === this.iType.RECEIVE) {
          return "receiving";
        } else if (this.item.type === this.iType.LEND) {
          return "lending";
        } else if (this.item.type === this.iType.BORROW) {
          return "borrowing";
        }
      }

      return "";
    },
    acceptCash() {
      return this.item.cash > 0;
    },
    acceptPoints() {
      return this.item.points > 0;
    },
    isFree() {
      return this.item.cash === 0 && this.item.points === 0;
    },
    getItemPriceMoney() {
      if (this.acceptCash) {
        return this.item.cash.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      }

      return "";
    },
    getItemPricePoints() {
      return this.acceptPoints ? this.item.points : "";
    },
    setDueDate() {
      let dueDate;
      if (
          this.activity.type === itemType.RECEIVE ||
          this.activity.type === itemType.BORROW
        ) {
          dueDate = this.activity.posterId === this.loggedUser.id ? 20 : 10;
        } else {
          dueDate = this.activity.posterId === this.loggedUser.id ? 10 : 20;
        }
        return dueDate;
    },
    acceptedRequest() {
      let d = new Date();
      let dueDate = 0;
      let updated = new Date();
      if (this.activity.requests?.length) {
        let result = {};
        result = this.activity.requests.find((request) => {
          dueDate = this.setDueDate;

          if (request.changeSituationAt) {
            updated = new Date(request.changeSituationAt);
            updated.setDate(updated.getDate() + dueDate);
          }
          return (
            request.situation === requestSituation.ACCEPTED &&
            (d > updated ||
              this.activity.status === itemStatus.NOT_SENT ||
              this.activity.status === itemStatus.NOT_RECEIVED)
          );
        });
        result = result ? result : {};
        return result;
      } else if (
        this.item.situation === requestSituation.ACCEPTED &&
        (this.activity.status === itemStatus.IDLE ||
          this.activity.posterId !== this.loggedUser.id)
      ) {
        dueDate = this.setDueDate;

        updated = this.setUpdated(dueDate)
        let result = {};
        if (
          d > updated ||
          this.activity.status === itemStatus.NOT_SENT ||
          this.activity.status === itemStatus.NOT_RECEIVED
        ) {
          result = this.item;
        }
        return result;
      } else {
        return {};
      }
    },
    numberOfRequestsOpen() {
      let reqsOpen = 0;
      this.item.requests.forEach((request) => {
        if (request.situation === this.reqSituation.OPEN) reqsOpen++;
      });

      return reqsOpen;
    },
    itemHaveRequests() {
      return this.numberOfRequestsOpen === 0
    },
    getTradeColor() {
      const type = this.item?.type ?? "";
      if (type === itemType.GIVE || type === itemType.LEND) {
        return "tertiary";
      } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
        return "offer";
      }

      return "";
    },
    getIconName() {
      return this.itemHaveRequests ? "mood_bad" : "mood";
    },
    interestedText() {
      return this.numberOfRequestsOpen.toString();
    },
    requestNumberText() {
      if (this.numberOfRequestsOpen.toString() === "1")
        return this.numberOfRequestsOpen.toString() + " Request";
      else
        return this.numberOfRequestsOpen.toString() + " Requests";
    },
    getAcceptedRequest() {
      let r = null;
      this.item.requests.forEach((request) => {
        if (request.situation === this.reqSituation.ACCEPTED) r = request;
      });

      return r;
    },
    isAcceptedRequest() {
      return this.getAcceptedRequest ? true : false;
    },
    getTimeStamp() {
      return this.getAcceptedRequest
        ? this.getTimeAgo(this.getAcceptedRequest.changeSituationAt)
        : "";
    },
    getAcceptedRequestValue() {
      let r = {
        value: "",
        type: "",
      };
      if (this.isAcceptedRequest) {
        if (this.getAcceptedRequest.payWith === "money") {
          if (this.item.points === 0 && this.item.cash === 0) {
            r = {
              value: "FREE",
              type: "free",
            };
          } else {
            let m = this.item.cash.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            });
            r = {
              value: m,
              type: "money",
            };
          }
        } else if (this.getAcceptedRequest.payWith === "points") {
          r = {
            value: this.item.points,
            type: "points",
          };
        }
      }

      return r;
    },
    getTextFromItemType() {
      return this.item.type === this.iType.RECEIVE || this.item.type === this.iType.BORROW ? "OFFER ACCEPTED" : "REQUEST ACCEPTED"
    }
  },
  mounted() {
    $(".name-tooltip").tooltip();
  },
};
</script>

<style lang="scss" scoped>
/* style for card */
.s-mypost-card {
  width: 100%;
  height: 100%;
  max-height: 500px;
  background-color: #FFF;
  box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.2);
  border-radius: 4px;
  padding: 1rem;

  display: flex;
  flex-direction: column;
  gap: 10px
}

.item-thumb-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.item-type-wrapper {
  width: 100%;
  height: 100%;
  min-height: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.post-tertiary .item-type-wrapper {
  background-color: $tertiary;
}

.post-offer .item-type-wrapper {
  background-color: $offer;
}
.post-trade-complete .item-type-wrapper {
  /* background-color: rgba(5, 145, 155, 0.04) !important; */
  background-color: $offer;
}

.item-type-text {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: white;
  margin: 0;
}

.item-trade-type-text {
  font-weight: 700;
  text-transform: uppercase;
}

.item-thumb-image {
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 5px;
}

.item-img {
  width: 100%;
  height: 100%;
  max-height: 180px;
  background-size: cover;
}

.item-content-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px
}

.item-content-header {
  width: 100%;
  height: 30%;

  display: flex;
  flex-direction: column;
}

.item-content-header-nameItem {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  margin: 0;
}

.item-content-header-posted {
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.6);
  margin: 0;

  visibility: hidden;
}

.item-content-header-posted-date {
  color: rgba(0,0,0,0.75);
  font-weight: bold;
}

.item-content-body{
  width: 100%;
  height: 100%;
}

.item-content-body-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
}

.item-body-payment-type {
  width: 100%;
}

.item-payment-type {
  width: 100%;
}

.item-body-info-boxes {
  width: 100%;
  height: 100%;

  display: flex;
  align-self: center;
  justify-content: center;
}

.item-price-mypost {
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0,0,0,0.7);
  margin: 0;
}

.request-accepted-box {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.request-accepted-box-icon {
  width: 30%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.request-accepted-box-text {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.accept-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 1.25px;
  color: rgba(0,0,0,0.7);
  margin: 0;
}

.request-accepted-ontime-timestamp {
  font-weight: 700;
  letter-spacing: 1.25px;
  color: $black;
  opacity: 0.6;
}

.ontime-timestamp {
  font-weight: 700;
  letter-spacing: 1.25px;
  color: $black;
  opacity: 0.6;
  text-align: right;
}

.trade-state-ontime {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.trade-completed-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: $primary;
  opacity: 0.5;
  text-align: right;
}

.item-content-actions {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px
}

.border-image-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
}

.border-image-offer {
  border: 3px solid $offer;
}

.trade-type-lend,
.trade-type-give,
.trade-type-receive,
.trade-type-borrow {
  color: white;
}

.item-details-action {
  width: 50%;
  min-height: 32px;
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px

}

.item-details-action--buttonRequests {
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.interested-item-mypost-btn {
  border: none !important;
  cursor: pointer;

  span {
    font-size: 14px;
  }
}

.item-details-action--icon {
  width: 30%;
  padding: 0.3rem;

  display: flex;
  justify-content: center;
}

.item-details-action-text{
  width: 100%;
  color: white;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: center;
}

.item-details-action.messages {
  margin-left: auto;
}

.item-details-action.active {
  cursor: pointer;
  background-color: $primary;
}

.item-details-action.disabled {
  background-color: rgba(0, 0, 0, 0.38);
}

.item-actions-confirm-sent {
  margin-top: 0 !important;
}

.item-actions-completed {
  justify-content: center !important;
  align-items: flex-end !important;
}
</style>

<style lang="scss" scoped>
@media only screen and (min-width: 769px) and (max-width: 1023px) {
  .s-mypost-card {
    flex-direction: row;
    align-items: center;
  }

  .item-thumb-wrapper {
    width: 60%;
  }

  .item-content-body {
    min-height: 70px;
  }

  .item-type-wrapper {
    height: 0;
  }
}

@media only screen and (min-width: 1024px) {
  .s-mypost-card {
    flex-direction: row;
    align-items: center;
  }

  .item-thumb-wrapper {
    width: 60%;
  }

  .item-content-body {
    min-height: 100px;
  }
}

@media only screen and (min-width: 1025px) {

  .item-content-wrapper {
    gap: 25px
  }

  .item-thumb-wrapper {
    width: 40%;
  }

  .item-content-body {
    min-height: 60px;
  }

  .request-accepted-box-icon {
    width: 10%;
  }

  .request-accepted-box-text {
    align-items: start;
  }

  .item-content-actions {
    margin-top: 1.5rem
  }

}
</style>
